/**
 *
 */
export class HierarchicalProperties
{
	/**
	 *
	 */
	public static MOUSE_ENABLED:number = 1;

	/**
	 *
	 */
	public static VISIBLE:number = 2;

	/**
	 *
	 */
	public static MASK_ID:number = 4;

	/**
	 *
	 */
	public static MASKS:number = 8;

	/**
	 *
	 */
	public static COLOR_TRANSFORM:number = 16;

	/**
	 *
	 */
	public static SCENE_TRANSFORM:number = 32;

	/**
	 *
	 */
	public static ALL:number = 63;
}